import { TaskType as GqlTaskType } from '@willow/graphql-iso/src/app/backend';
import { TaskType } from '@willow/types-iso';

import { convertGqlEnumToEnum } from './convertEnumToGqlEnum';

export const gqlTaskTypeToTaskType = convertGqlEnumToEnum<typeof GqlTaskType, TaskType>(GqlTaskType);
